import { msg } from 'gt-react';
import { ReceiptIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const VDMsPage = lazyRouteComponent(
  () => import('../vdms/VDMsPage'),
  'VDMsPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/vdm',
  staticData: {
    app: {
      nav: {
        label: msg('VDMs', {
          context: 'sidebar nav label, Ship and Debit section',
        }),
        icon: <ReceiptIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit',
        order: 30,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.VDM }],
      },
    },
  },
  component: VDMsPage,
  loader: () => ({
    crumb: msg('VDMs', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.VDM,
    });
  },
  validateSearch: z.object({
    status: z.array(z.string()).optional(),
    supplierId: z.string().optional(),
    companyCode: z.string().optional(),
    divisionCode: z.string().optional(),
    search: z.string().optional(),
    createdAtFrom: z.string().optional(),
    createdAtTo: z.string().optional(),
    sortBy: z.string().optional(),
    sortOrder: z.enum(['ASC', 'DESC']).optional(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
  }),
});
